// src/prototype/config/demoFlags.ts
// ============================================================
// DEMO PRESENTATION FLAGS
// Scaffolding that shouldn't appear in the live demo is gated here.
// ============================================================

// P15: hide the "Start Ingestion (Coming Soon)" and "Execution Support
// (Coming Soon)" blocks in the demo. Flip to true to show the roadmap stubs.
export const SHOW_COMING_SOON = false;

// P13: the Reset Demo control is hidden in the demo (it runs in dev mode, so an
// import.meta.env.DEV gate is not enough). Show it only with ?demoControls=true.
export function showDemoControls(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has('demoControls');
}
